<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.customer_feature.customer_profile') }}
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-sm-12 col-lg-6 col-md-6">
              <div class="form-group row m-b-t-15">
                <label class="col-md-3 form-col-label control-label required">
                  {{ $t('addministration.customer_feature.name') }}</label
                >
                <div class="col-md-7">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('customer_name') }"
                    v-model="model.customer_name"
                    ref="customer_name"
                    placeholder="Enter customer name"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('customer_name')"
                  >
                    {{ errors.first('customer_name') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-15">
                <label class="col-md-3 col-form-label control-label required"
                  >{{ $t('addministration.customer_feature.gender') }}
                </label>
                <div class="col-md-7">
                  <div
                    class="radio radio-css radio-inline"
                    :class="{ 'is-invalid': errors.has('gender') }"
                  >
                    <input
                      type="radio"
                      v-model="model.gender"
                      value="Male"
                      id="male"
                    />
                    <label for="male">{{
                      $t('addministration.customer_feature.male')
                    }}</label>
                  </div>
                  <div
                    class="radio radio-css radio-inline"
                    :class="{ 'is-invalid': errors.has('gender') }"
                  >
                    <input
                      :class="{ 'is-invalid': errors.has('gender') }"
                      type="radio"
                      v-model="model.gender"
                      value="Female"
                      id="female"
                    />
                    <label for="female">{{
                      $t('addministration.customer_feature.female')
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-15">
                <label class="col-md-3 col-form-label control-label "
                  >{{ $t('addministration.customer_feature.date_of_birth') }}
                </label>
                <div class="col-md-7">
                  <ts-date-picker-input
                    v-model="model.date_of_birth"
                    placeholder="Date of Birth"
                  />
                  <div style="color:#cc4946;margin:4px 0 0">
                    {{ errors.first('date_of_birth') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-3 form-col-label control-label required">
                  {{
                    $t('addministration.customer_feature.contact_no_1')
                  }}</label
                >
                <div class="col-md-7">
                  <input
                    v-model="model.contact_no1"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('contact_no1') }"
                    placeholder="Enter contact no 1"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('contact_no1')"
                  >
                    {{ errors.first('contact_no1') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-3 form-col-label control-label">
                  {{ $t('addministration.customer_feature.contact_no_2') }}
                </label>
                <div class="col-md-7">
                  <input
                    v-model="model.contact_no2"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('contact_no2') }"
                    placeholder="Enter contact no 2"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('contact_no2')"
                  >
                    {{ errors.first('contact_no2') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-3 form-col-label control-label">
                  {{ $t('addministration.customer_feature.passport') }}
                </label>
                <div class="col-md-7">
                  <input
                    v-model="model.nid_passport"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('nid_passport') }"
                    placeholder="Enter passport"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('nid_passport')"
                  >
                    {{ errors.first('nid_passport') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-lg-6 col-md-6">
              <div class="form-group row m-b-t-15">
                <label class="col-md-3 form-col-label control-label required">
                  {{
                    $t('addministration.customer_feature.service_type')
                  }}</label
                >
                <div class="col-md-7">
                  <select
                    v-model.number="model.service_type_id"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('service_type_id') }"
                  >
                    <option value="" disabled selected style="display: none;">
                      --{{
                        $t('addministration.customer_feature.select')
                      }}--</option
                    >
                    <option
                      v-for="(service_type, index) in service_types"
                      :key="index"
                      :value="service_type.service_type_id"
                    >
                      {{ service_type.service_name_en }}
                    </option>
                  </select>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('service_type_id')"
                  >
                    {{ errors.first('service_type_id') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-3 form-col-label control-label required">
                  {{
                    $t('addministration.customer_feature.customer_type')
                  }}</label
                >
                <div class="col-md-7">
                  <select
                    v-model.number="model.cus_type_id"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('cus_type_id') }"
                  >
                    <option value="" disabled selected style="display: none;">
                      --{{
                        $t('addministration.customer_feature.select')
                      }}--</option
                    >
                    <option
                      v-for="(customer_type, index) in customer_types"
                      :key="index"
                      :value="customer_type.cus_type_id"
                    >
                      {{ customer_type.cus_type }}
                    </option>
                  </select>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('cus_type_id')"
                  >
                    {{ errors.first('cus_type_id') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-3 form-col-label control-label required">
                  {{
                    $t('addministration.customer_feature.customer_zone')
                  }}</label
                >
                <div class="col-md-7">
                  <div class="input-group">
                    <select
                      v-model.number="model.cus_zone_id"
                      type="text"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('cus_zone_id') }"
                    >
                      <option value="" disabled selected style="display: none;">
                        --{{
                          $t('addministration.customer_feature.select')
                        }}--</option
                      >
                      <option
                        v-for="(customer_zone, index) in customer_zones"
                        :key="index"
                        :value="customer_zone.cus_zone_id"
                      >
                        {{ customer_zone.cus_zone_name }}
                      </option>
                    </select>
                    <div class="input-group-addon">
                      <router-link
                        class="text-info"
                        :to="{
                          name: 'customer-zone'
                        }"
                        v-tooltip="
                          $t(
                            'addministration.customer_feature.add_customer_zone'
                          )
                        "
                      >
                        <i class="fas fa-plus"></i>
                      </router-link>
                    </div>
                  </div>
                  <div class="validate" v-if="errors.has('cus_zone_id')">
                    {{ errors.first('cus_zone_id') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-3 form-col-label control-label">
                  {{ $t('addministration.customer_feature.permanent_address') }}
                </label>
                <div class="col-md-7">
                  <textarea
                    class="form-control"
                    rows="3"
                    v-model="model.permanent_address"
                    placeholder="Enter permanent address here..."
                  >
                  </textarea>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('permanent_address')"
                  >
                    {{ errors.first('permanent_address') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-3 form-col-label control-label">
                  {{ $t('addministration.customer_feature.current_address') }}
                </label>
                <div class="col-md-7">
                  <textarea
                    class="form-control"
                    rows="3"
                    v-model="model.current_addresss"
                    placeholder="Enter current address here..."
                  >
                  </textarea>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('current_addresss')"
                  >
                    {{ errors.first('current_addresss') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-3 form-col-label control-label"> </label>
                <div class="col-md-7">
                  <ts-checkbox v-model="model.is_default">{{
                    $t('addministration.customer_feature.is_default')
                  }}</ts-checkbox>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="row  text-right">
            <div class="col-lg-12">
              <ts-button
                class="ml-2"
                color="primary"
                :waiting="saving"
                @click="update"
              >
                {{ $t('addministration.customer_feature.update') }}
              </ts-button>

              <ts-button
                class="ml-2"
                @click="$router.push({ name: 'customer-profile' })"
              >
                {{ $t('addministration.customer_feature.cancel') }}
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'customer-profile-edit',
  props: ['customerProfile'],
  data() {
    return {
      model: _.cloneDeep(this.customerProfile),
      saving: false,
      errors: new Errors()
    }
  },
  mounted() {
    this.$refs.customer_name.focus()
  },
  created() {},
  computed: {
    ...mapState('customerProfile', [
      'customer_types',
      'customer_zones',
      'service_types'
    ])
  },
  methods: {
    update() {
      this.saving = true
      this.errors = new Errors()
      this.$store
        .dispatch('customerProfile/update', Object.assign({}, this.model))
        .then(respons => {
          this.$toasted.success(respons.message)
          this.$router.push({ name: 'customer-profile' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('customerProfile/SET_CUSTOMER_TYPES', [])
    this.$store.commit('customerProfile/SET_CUSTOMER_ZONES', [])
    this.$store.commit('customerProfile/SET_SERVICE_TYPES', [])
    next()
  }
}
</script>
